import { ICSVFormat } from "../../models/csv_format.ts";

export const validateCSVFormat = (csv: ICSVFormat): ICSVFormat => {
  if (typeof csv !== "object" || csv === null) {
    throw new Error("入力はオブジェクトである必要があります");
  }

  const requiredFields = [
    "title",
    "body",
    "draft",
    "section_id",
    "permission_group_id",
  ];
  for (const field of requiredFields) {
    if (!(field in csv)) {
      throw new Error(`${field}は必須フィールドです`);
    }
  }

  if (typeof csv.draft !== "boolean") {
    throw new Error("draftはTrueかFalseである必要があります");
  }
  if (typeof csv.section_id !== "number") {
    throw new Error("section_idは数値である必要があります");
  }
  if (typeof csv.permission_group_id !== "number") {
    throw new Error("permission_group_idは数値である必要があります");
  }

  if (csv.id !== null && typeof csv.id !== "number") {
    console.log(csv.id);
    throw new Error("idは数値である必要があります");
  }
  if (csv.user_segment_id !== null && typeof csv.user_segment_id !== "number") {
    throw new Error("user_segment_idは空白か数値である必要があります");
  }

  const alphanumericRegex = /^[a-zA-Z0-9]*$/;
  for (let i = 1; i <= 5; i++) {
    const tagKey = `content_tag_id${i}` as keyof ICSVFormat;
    if (tagKey in csv && csv[tagKey] !== null) {
      if (!alphanumericRegex.test(csv[tagKey] as string)) {
        throw new Error(`${tagKey}は英数字のみを含む必要があります`);
      }
    }
  }
  return csv as ICSVFormat;
};
